module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-breadcrumb', [_c('vbl-breadcrumb-item', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _c('vbl-breadcrumb-item', {
    attrs: {
      "to": "/detail"
    }
  }, [_vm._v("详情页")]), _c('vbl-breadcrumb-item', [_vm._v("编辑")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d914927","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblBreadcrumb/example/vblBreadcrumbExample.vue
// module id = 265
// module chunks = 0